export default "__VITE_ASSET__C44$3wMk__"